export default "__VITE_ASSET__BCHXT82G__"